import React from "react";
import { rowColumn } from "../../../components/table/Table";
import { assignStatusPrimaryOptions, assignStatusSecondaryOptions } from "../../formObjects/application/assignStatusForm";
import { getFilterOptions } from "../../CommonFunctions";

export const myApplicationsListTable = (currPath: string): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "First Name",
    column: "firstName",
    type: "string",
    allowSort: true,
    sortOn: "FirstName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Last Name",
    column: "lastName",
    type: "string",
    allowSort: true,
    sortOn: "LastName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Kindergarten",
    column: "fundedKinderName",
    type: "string",
    allowSort: true,
    sortOn: "FundedKinderName",
    body: (rowData) => {
      return <p className="m-0">{rowData.fundedKinderName === "Other" ? rowData.kindergartenNameOther : rowData.fundedKinderName}</p>;
    },
    isFilter: true,
    filterType: "search",
    filterKeyColumns: ["fundedKinderName", "kindergartenNameOther"],
  },
  {
    label: "Status",
    column: "statusComputed",
    type: "string",
    allowSort: true,
    sortOn: "StatusComputed",
    isFilter: true,
    filterType: "multiselect",
    filterElements: getFilterOptions(assignStatusPrimaryOptions, assignStatusSecondaryOptions, [
      { secondaryOption: "Presubmission" },
      { secondaryOption: "Withdrawn" },
    ]),
  },
  {
    label: "Date Submitted",
    column: "dateSubmitted",
    type: "date",
    allowSort: true,
    sortOn: "DateSubmitted",
  },
  {
    label: "KPI",
    column: "kpi",
    type: "number",
    allowSort: true,
    sortOn: "KPI",
    body: (rowData) => {
      let kpiStatusColor = "";
      const kpiValue = rowData.kpi;
      const status = rowData.assignStatus;

      if (status != "Application" && kpiValue >= 7 && kpiValue <= 10) {
        kpiStatusColor = "kpi-status kpi-green";
      } else if (status != "Application" && kpiValue >= 4 && kpiValue <= 6) {
        kpiStatusColor = "kpi-status kpi-yellow";
      } else if (status != "Application" && kpiValue >= 1 && kpiValue <= 3) {
        kpiStatusColor = "kpi-status kpi-orange";
      } else if (kpiValue == 4 || kpiValue == 3) {
        kpiStatusColor = "kpi-status kpi-green";
      } else if (kpiValue == 2) {
        kpiStatusColor = "kpi-status kpi-yellow";
      } else if (kpiValue == 1) {
        kpiStatusColor = "kpi-status kpi-orange";
      } else if (kpiValue != null && kpiValue <= 0) {
        kpiStatusColor = "kpi-status kpi-red";
      } else {
        kpiStatusColor = "kpi-status border-transparent";
      }
      return (
        <span className={kpiValue != null ? `${kpiStatusColor}` : "kpi-status border-transparent"}>
          {kpiValue != null || kpiValue != undefined ? kpiValue : "—"}
        </span>
      );
    },
  },
  {
    label: "Actions",

    body: (rowData) => <a href={`${currPath}/${rowData.discriminator}/${rowData.id}`}>View Details</a>,
  },
];
